import { createPinia } from "pinia";
import { createApp } from "vue";

import App from "@/App.vue";
import { router } from "@/router";
import { installE2eGlobalErrorBridge } from "@/runtime/e2eGlobalErrorBridge";
import { installGlobalErrorHandlers } from "@/runtime/globalErrors";
import { useRuntimeErrorStore } from "@/stores/runtimeError";

import "../styles.css";

const app = createApp(App);
const pinia = createPinia();
app.use(pinia).use(router);
installGlobalErrorHandlers(app, router, useRuntimeErrorStore(pinia));
installE2eGlobalErrorBridge(app);
app.mount("#app");
